import React, { useEffect, useRef, useState } from 'react'
import app from 'scripts/init/react/Bootstrapper'
import SVG from 'scripts/components/SVGs'
import apiFetch from '@wordpress/api-fetch'
import { parse, stringify } from 'query-string'

export const renderRichText = (value, tagName, props = {}) => {
  return typeof value === 'string'
    ? React.createElement(tagName, {
        ...props,
        dangerouslySetInnerHTML: { __html: value },
      })
    : value
}

export const useInnerBlocks = (...atts) => {
  const ref = useRef()

  useEffect(() => {
    if (ref.current) {
      app.update(ref.current)
    }
  })

  const InnerBlocks = renderRichText(...atts)

  return { InnerBlocks, ref }
}

export const RenderIconInline = ({ icon, ...props }) => {
  if (!React.isValidElement(icon)) {
    return <SVG {...icon} isInline {...props} />
  }
  return icon || null
}

export const themeColors = [
  {
    name: 'Primary',
    slug: 'primary',
    color: 'var(--primary)',
  },
  {
    name: 'Secondary',
    slug: 'secondary',
    color: 'var(--secondary)',
  },
  {
    name: 'Tertiary',
    slug: 'tertiary',
    color: 'var(--tertiary)',
  },
  {
    name: 'Dark',
    slug: 'dark',
    color: 'var(--dark)',
  },
  {
    name: 'Light',
    slug: 'light',
    color: 'var(--light)',
  },
  {
    name: 'White',
    slug: 'white',
    color: 'var(--white)',
  },
]

export const getAllSameBlocks = (name, clientId, select) => {
  const blockList = []
  const addBlock = newBlock => {
    blockList.push(newBlock)
  }
  const getBlocks = (blocks, addNewBlock = () => {}) => {
    blocks.forEach(block => {
      addNewBlock(block)
      if (block.innerBlocks.length) {
        getBlocks(block.innerBlocks, addNewBlock)
      }
    })
  }
  const rootBlocks = select('core/block-editor').getBlocks()
  getBlocks(rootBlocks, addBlock)
  return blockList.filter(
    pageBlock => pageBlock.name === name && pageBlock.clientId !== clientId
  )
}

export const usePosttypes = (useTypes = []) => {
  const [posttypes, setPosttypes] = useState()

  useEffect(() => {
    apiFetch({ path: '/wp/v2/types' }).then(data => {
      const types = Object.values(data)
        .filter(item =>
          useTypes.length > 0 ? useTypes.includes(item.slug) : true
        )
        .map(type => {
          return {
            value: type.slug,
            label: type.name,
          }
        })
      setPosttypes(types)
    })
  }, [])

  return posttypes
}

export const usePosttypeSelect = (posttype = 'posts') => {
  const [posts, setPosts] = useState([])

  useEffect(() => {
    apiFetch({ path: '/wp/v2/' + posttype + '/?per_page=100' })
      .then(data => {
        if (data) {
          const options = Object.values(data).map(type => {
            return {
              label: type.title.rendered,
              value: type.id,
            }
          })
          setPosts(options)
        } else {
          console.warn('no data from', '/wp/v2/' + posttype) //eslint-disable-line
        }
      })
      .catch(err => {
        console.warn('no data from', '/wp/v2/' + posttype, err) //eslint-disable-line
      })
  }, [])

  return posts
}

export const useTaxSelect = (tax = 'posts') => {
  const [terms, setTerms] = useState([])

  useEffect(() => {
    apiFetch({ path: '/wp/v2/' + tax + '/?per_page=100' })
      .then(data => {
        if (data) {
          const options = Object.values(data).map(type => {
            return {
              label: type.name,
              value: type.term_id,
            }
          })
          setTerms(options)
        } else {
          console.warn('no data from', '/wp/v2/' + tax) //eslint-disable-line
        }
      })
      .catch(err => {
        console.warn('no data from', '/wp/v2/' + tax, err) //eslint-disable-line
      })
  }, [])

  return terms
}

export const useRestAPI = (url = '', init = [], exclude = [], fields = []) => {
  const [data, setData] = useState(init)
  const [loading, setLoading] = useState(false)
  const [totalPages, setTotalPages] = useState(0)
  const [totalItems, setTotalItems] = useState(0)

  const urlComponents = url.split('?')

  const queryObj = {
    ...parse(urlComponents[1]),
    ...(exclude.length ? { exclude: exclude.join(',') } : {}),
    ...(fields.length ? { _fields: fields.join(',') } : {}),
  }

  const queryString = stringify(queryObj)

  useEffect(() => {
    if (url) {
      setLoading(true)
      fetch(`${urlComponents[0]}${queryString ? '?' + queryString : ''}`)
        .then(resp => {
          setTotalPages(Number(resp.headers.get('x-wp-totalpages')))
          setTotalItems(Number(resp.headers.get('x-wp-total')))
          return resp.json()
        })
        .then(restData => {
          setData(restData)
          setLoading(false)
        })
    }
  }, [url, exclude.length])

  return [data, loading, totalPages, totalItems]
}
